// import React, { Fragment, useState, useEffect, useRef } from 'react';
// import { Btn, Spinner } from '../../../AbstractElements';
// import { Card, CardBody, Col, FormGroup, Label, Row } from 'reactstrap';
// import axios from 'axios';
// import config from '../../../config';
// import { toast } from 'react-toastify';
// import { DataGrid } from '@mui/x-data-grid';
// import { AgGridReact } from 'ag-grid-react';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';


// const DataGridView = () => {
//     if (localStorage.getItem("accessDataGrid") !== "1") {
//         alert('You are not authorized to view this page');
//         window.history.back(); // Navigate back to the previous URL
//     }

//     const gridRef = useRef(null);
//     const concessionaire_id = localStorage.getItem("concessionaireId");
//     const property_access = localStorage.getItem("propertyAccess");
//     const [propertyAccessNames, setPropertyAccesssNames] = useState('');
//     const login_name = localStorage.getItem("loginName");
//     const login_id = localStorage.getItem("loginId");
//     const [startDate, setStartDate] = useState('');
//     const [endDate, setEndDate] = useState('');
//     const [deliveryPartners, setDeliveryPartners] = useState([]);
//     const [reportData, setReportData] = useState([]);
//     const [totalCount, setTotalCount] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const today = new Date().toISOString().split('T')[0];
//     const [validationMessage, setValidationMessage] = useState('');
//     const token = localStorage.getItem("sessiontoken");
//     const usertype = localStorage.getItem('usertype');
//     const configheader = {
//         headers: {
//             Authorization: `${token}`
//         }
//     };


//     const handleStartDateChange = (e) => {
//         setStartDate(e.target.value);
//         setReportData([]);
//     };

//     const handleEndDateChange = (e) => {
//         setEndDate(e.target.value);
//         setReportData([]);
//     };

//     useEffect(() => {
//         axios
//             .post(`${config.hostname}/concessionairedeliverypartner/getdeliverypartner`, { concessionaire_id }, configheader)
//             .then((response) => {
//                 const deliveryPartnerNames = response.data.map(item => item.delivery_partner_id.delivery_partner_name)
//                     .filter(name => name !== "Dine In");
//                 setDeliveryPartners(deliveryPartnerNames);
//             })
//             .catch((error) => {
//                 console.log(error);
//             });
//     }, []);

//     // const generateReport = async (e0) => {
//     //     e.preventDefault();
//     //     if (endDate < startDate) {
//     //         setValidationMessage('End date cannot be less than start date');
//     //         return;
//     //     } else {
//     //         setValidationMessage('');
//     //     }

//     //     const data = {
//     //         concessionaire_id,
//     //         property_access: propertyAccessNames,
//     //         start_date: startDate,
//     //         end_date: endDate,
//     //     };

//     //     setLoading(true);
//     //     axios
//     //         .post(`${config.hostname}/datagrid/getdatagrid`, data, configheader)
//     //         .then((response) => {
//     //             setReportData(response.data.data);
//     //             setTotalCount(response.data.totalCount);
//     //             setLoading(false);
//     //             insertToLog(" viewed data grid");
//     //         })
//     //         .catch((error) => {
//     //             toast.error('Error');
//     //             setLoading(false);
//     //             console.log(error);
//     //         });
//     // };

//     const fetchReport = async (skip = 0, limit = 100) => {
//         try {
//             if (endDate < startDate) {
//                 setValidationMessage('End date cannot be less than start date');
//                 return;
//             }
//             setValidationMessage('');

//             const data = {
//                 concessionaire_id,
//                 property_access: propertyAccessNames,
//                 start_date: startDate,
//                 end_date: endDate,
//                 skip,
//                 limit
//             };

//             setLoading(true);
//             const response = await axios.post(`${config.hostname}/datagrid/getdatagrid`, data, configheader);
//             setReportData(response.data.data);
//             setTotalCount(response.data.totalCount);
//             insertToLog(" viewed data grid");
//         } catch (err) {
//             console.error(err);
//             toast.error("Error");
//         } finally {
//             setLoading(false);
//         }
//     };



//     const insertToLog = (task) => {
//         const data = {
//             created_by: login_id,
//             concessionaire_id: concessionaire_id,
//             module: "Data Grid",
//             task: login_name + task
//         };
//         axios
//             .post(`${config.hostname}/log`, data, configheader)
//             .then(() => console.log("inserted to log table"))
//             .catch((error) => {
//                 toast.error('Error');
//                 console.log(error);
//             });
//     };

//     const columns = [
//         { field: 'tenant_store_name', headerName: 'Tenant Name', width: 150 },
//         { field: 'tenant_group_name', headerName: 'Group Name', width: 200 },
//         { field: 'tenant_code', headerName: 'Tenant Code', width: 150 },
//         { field: 'tenant_unit_code', headerName: 'Unit Code', width: 150 },
//         { field: 'tenant_status', headerName: 'Status', width: 150 },
//         { field: 'property_name', headerName: 'Property', width: 150 },
//         { field: 'subcategory_name', headerName: 'Subcategory', width: 200 },
//         { field: 'floor', headerName: 'Floor', width: 100 },
//         { field: 'transaction_date', headerName: 'Date', width: 150 },
//         { field: 'transaction_count', headerName: 'Transaction Count', width: 150 },
//         {
//             field: 'net_sales',
//             headerName: 'Net Sales',
//             width: 150,
//             type: 'number',
//             valueFormatter: (params) => params?.value != null ? params.value.toFixed(2) : '0.00',
//         },
//         { field: 'gross_amount', headerName: 'Gross Amount', width: 200 },
//         { field: 'tax_amount', headerName: 'Tax Amount', width: 100 },
//         { field: 'discount_amount', headerName: 'Discount Amount', width: 150 },
//         { field: 'return_amount', headerName: 'Return Amount', width: 150 },
//     ];

//     deliveryPartners.forEach((partner) => {
//         const normalizedPartner = partner.toLowerCase().replace(/\s+/g, '_');
//         columns.push({ field: `${normalizedPartner}_count`, headerName: `${partner} Count`, width: 150 });
//         columns.push({
//             field: `${normalizedPartner}_sales`,
//             headerName: `${partner} Sales`,
//             width: 150,
//             type: 'number',
//             valueFormatter: (params) => params?.value != null ? params.value.toFixed(2) : '0.00',
//         });
//     });

//     const exportToCSV = () => {
//         gridRef.current.api.exportDataAsCsv({
//             fileName: 'grid_data.csv', // Name of the CSV file
//             columnSeparator: ',' // Optional: You can set a different separator
//         });
//     };

//     const reset = () => {
//         setStartDate('')
//         setEndDate('')
//         setReportData([])
//     };

//     return (
//         <Fragment>
//             <div className='theme-form'>
//                 <Card>
//                     <CardBody>
//                         <Row>
//                             <Col>
//                                 <FormGroup className="mb-3">
//                                     <Label htmlFor="startdate">Start Date</Label>
//                                     <input className="form-control digits"
//                                         id="startdate" type="date" name="startdate" value={startDate}
//                                         max={today} onChange={handleStartDateChange} required />
//                                 </FormGroup>
//                             </Col>
//                             <Col>
//                                 <FormGroup className="mb-3">
//                                     <Label htmlFor="enddate">End Date</Label>
//                                     <input className="form-control digits"
//                                         id="enddate" type="date" name="enddate" value={endDate}
//                                         max={today} onChange={handleEndDateChange} required />
//                                 </FormGroup>
//                                 {validationMessage && (
//                                     <span className="text-danger">{validationMessage}</span>
//                                 )}
//                             </Col>
//                         </Row>
//                         <Row>
//                             <Col >
//                                 <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: () => fetchReport(0, 100) }} >Load Data</Btn>
//                                 <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
//                             </Col>
//                         </Row>
//                     </CardBody>
//                 </Card>
//             </div>
//             {loading ? (
//                 <div className="loader-box">
//                     <Spinner attrSpinner={{ className: 'loader-3' }} />
//                 </div>
//             ) : (
//                 // <div style={{ height: 600, width: '100%' }}>
//                 //     <DataGrid
//                 //         rows={reportData}
//                 //         columns={columns}
//                 //         pageSize={10}
//                 //         rowsPerPageOptions={[10, 20, 50]}
//                 //         pagination
//                 //         disableSelectionOnClick
//                 //         sortingOrder={['asc', 'desc']}
//                 //         getRowId={(row) => row.tenant_code} // Use a unique field as the ID
//                 //     />
//                 // </div>

//                 <div>
//                     <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: exportToCSV }} >Export to CSV</Btn>
//                     <div className="ag-theme-alpine" style={{ height: 600, width: '100%' }}>
//                         {/* <AgGridReact
//                             ref={gridRef}
//                             rowData={reportData}
//                             columnDefs={columns}
//                             pagination={true}
//                             paginationPageSize={10}
//                             gridOptions={{
//                                 sideBar: {
//                                     toolPanels: ['columns'],  // Column selection panel
//                                     defaultToolPanel: 'columns'  // Open the "Columns" panel by default
//                                 },
//                                 pagination: true,
//                                 paginationPageSize: 10,
//                             }}
//                             defaultColDef={{
//                                 sortable: true,
//                                 filter: true,
//                                 floatingFilter: true,
//                                 resizable: true,
//                             }}
//                         /> */}
//                         <AgGridReact
//                             rowData={reportData}
//                             columnDefs={columns}
//                             pagination={true}
//                             paginationPageSize={100}
//                             onPaginationChanged={(params) => {
//                                 if (params.api) {
//                                     const currentPage = params.api.paginationGetCurrentPage();
//                                     const pageSize = params.api.paginationGetPageSize();
//                                     const skip = currentPage * pageSize;
//                                     fetchReport(skip, pageSize); // ✅ works fine
//                                 }
//                             }}

//                             gridOptions={{
//                                 sideBar: {
//                                     toolPanels: ['columns'],  // Column selection panel
//                                     defaultToolPanel: 'columns'  // Open the "Columns" panel by default
//                                 },
//                                 pagination: true,
//                                 paginationPageSize: 10,
//                             }}
//                             defaultColDef={{
//                                 sortable: true,
//                                 filter: true,
//                                 floatingFilter: true,
//                                 resizable: true,
//                             }}
//                         />

//                     </div>
//                 </div>

//             )}
//         </Fragment>
//     );
// };

// export default DataGridView;

import React, { Fragment, useState, useEffect, useRef, useMemo } from 'react';
import { Btn, Spinner } from '../../../AbstractElements';
import { Card, CardBody, Col, FormGroup, Label, Row } from 'reactstrap';
import axios from 'axios';
import config from '../../../config';
import { toast } from 'react-toastify';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

// source: 'live' (default) | 'uat' - selects which set of collections the grid reads.
const DataGridView = ({ source = 'live' }) => {
    if (localStorage.getItem("accessDataGrid") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back();
    }

    const isUat = source === 'uat';
    const gridUrl = isUat
        ? `${config.hostname}/datagrid/getdatagriduat`
        : `${config.hostname}/datagrid/getdatagrid`;

    const gridApiRef = useRef(null);

    const PAGE_SIZE = 100;

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const [propertyAccessNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [deliveryPartners, setDeliveryPartners] = useState([]);

    const [loading, setLoading] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [rows, setRows] = useState([]);        // current page rows
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);         // 1-based page index

    const today = new Date().toISOString().split('T')[0];
    const token = localStorage.getItem("sessiontoken");
    const configheader = useMemo(() => ({ headers: { Authorization: `${token}` } }), [token]);

    // delivery partners (for columns)
    useEffect(() => {
        (async () => {
            try {
                const res = await axios.post(
                    `${config.hostname}/concessionairedeliverypartner/getdeliverypartner`,
                    { concessionaire_id },
                    configheader
                );
                const names = res.data
                    .map(item => item?.delivery_partner_id?.delivery_partner_name)
                    .filter(Boolean)
                    .filter(n => n !== 'Dine In');
                setDeliveryPartners(names);
            } catch (e) {
                console.error(e);
            }
        })();
    }, [concessionaire_id, configheader]);

    const columns = useMemo(() => {
        const base = [
            { field: 'tenant_store_name', headerName: 'Tenant Name', width: 150 },
            { field: 'tenant_group_name', headerName: 'Group Name', width: 200 },
            { field: 'tenant_code', headerName: 'Tenant Code', width: 150 },
            { field: 'tenant_unit_code', headerName: 'Unit Code', width: 150 },
            { field: 'tenant_status', headerName: 'Status', width: 150 },
            { field: 'property_name', headerName: 'Property', width: 150 },
            { field: 'subcategory_name', headerName: 'Subcategory', width: 200 },
            { field: 'floor', headerName: 'Floor', width: 100 },
            { field: 'transaction_date', headerName: 'Date', width: 150 },
            { field: 'transaction_count', headerName: 'Transaction Count', width: 150 },
            {
                field: 'net_sales', headerName: 'Net Sales', width: 150, type: 'number',
                valueFormatter: (p) => p?.value != null ? Number(p.value).toFixed(2) : '0.00',
            },
            { field: 'gross_amount', headerName: 'Gross Amount', width: 200 },
            { field: 'tax_amount', headerName: 'Tax Amount', width: 100 },
            { field: 'discount_amount', headerName: 'Discount Amount', width: 150 },
            { field: 'return_amount', headerName: 'Return Amount', width: 150 },
        ];
        const partnerCols = deliveryPartners.flatMap((partner) => {
            const normalized = partner.toLowerCase().replace(/\s+/g, '_');
            return [
                { field: `${normalized}_count`, headerName: `${partner} Count`, width: 150 },
                {
                    field: `${normalized}_sales`, headerName: `${partner} Sales`, width: 150, type: 'number',
                    valueFormatter: (p) => p?.value != null ? Number(p.value).toFixed(2) : '0.00',
                }
            ];
        });
        return [...base, ...partnerCols];
    }, [deliveryPartners]);

    const insertToLog = (task) => {
        const payload = {
            created_by: login_id,
            concessionaire_id,
            module: isUat ? "UAT Data Grid" : "Data Grid",
            task: login_name + task
        };
        axios.post(`${config.hostname}/log`, payload, configheader).catch(() => { });
    };

    // state/refs
    const filterModelRef = useRef({});
    const sortModelRef = useRef([]);
    const filterDebounce = useRef(null);

    // grid events
    const onGridReady = (p) => { gridApiRef.current = p.api; };

    const onFilterChanged = () => {
        if (!gridApiRef.current) return;
        filterModelRef.current = gridApiRef.current.getFilterModel() || {};
        clearTimeout(filterDebounce.current);
        filterDebounce.current = setTimeout(() => fetchPage(1), 350); // debounce typing
    };

    const onSortChanged = () => {
        if (!gridApiRef.current) return;
        sortModelRef.current = gridApiRef.current.getSortModel() || [];
        fetchPage(1);
    };


    // fetch a specific page from the server
    // const fetchPage = async (pageIndex) => {
    //     try {
    //         if (!startDate || !endDate) {
    //             setValidationMessage('Please select both start & end dates');
    //             return;
    //         }
    //         if (endDate < startDate) {
    //             setValidationMessage('End date cannot be less than start date');
    //             return;
    //         }
    //         setValidationMessage('');

    //         setLoading(true);

    //         const skip = (pageIndex - 1) * PAGE_SIZE;
    //         const limit = PAGE_SIZE;

    //         const payload = {
    //             concessionaire_id,
    //             property_access: propertyAccessNames,
    //             start_date: startDate,
    //             end_date: endDate,
    //             skip,
    //             limit
    //         };

    //         const res = await axios.post(`${config.hostname}/datagrid/getdatagrid`, payload, configheader);
    //         const data = Array.isArray(res.data?.data) ? res.data.data : [];
    //         const total = Number(res.data?.totalCount || 0);

    //         setRows(data);
    //         setTotalCount(total);
    //         setPage(pageIndex);

    //         insertToLog(" viewed data grid");
    //     } catch (e) {
    //         console.error(e);
    //         toast.error('Error loading data');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchPage = async (pageIndex) => {

        if (startDate === '' || endDate === '') {
            toast.warning('Select start date and end date')
            return
        }
        try {
            const skip = (pageIndex - 1) * PAGE_SIZE;
            const firstSort = (sortModelRef.current && sortModelRef.current[0]) || {};
            const sortField = firstSort.colId || undefined;
            const sortDir = firstSort.sort || undefined;

            const payload = {
                concessionaire_id,
                property_access: propertyAccessNames,
                start_date: startDate,
                end_date: endDate,
                skip,
                limit: PAGE_SIZE,
                filterModel: filterModelRef.current,
                sortField,
                sortDir,
                source
            };

            const res = await axios.post(
                gridUrl,
                payload,
                configheader
            );

            setRows(res.data?.data ?? []);
            setTotalCount(Number(res.data?.totalCount || 0));
            setPage(pageIndex);
        } catch (error) {
            console.error("Error fetching page data:", error.message);


            setRows([]);
            setTotalCount(0);

            toast.error("No data");
        }
    };


    const defaultColDef = {
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        filterParams: { debounceMs: 300, suppressAndOrCondition: true, caseSensitive: false }
    };



    const onClickLoadData = () => {
        fetchPage(1);
    };

    const canPrev = page > 1;
    const totalPages = Math.max(1, Math.ceil(totalCount / PAGE_SIZE));
    const canNext = page < totalPages;

    const goPrev = () => { if (canPrev) fetchPage(page - 1); };
    const goNext = () => { if (canNext) fetchPage(page + 1); };



    const reset = () => {
        setStartDate('');
        setEndDate('');
        setRows([]);
        setTotalCount(0);
        setPage(1);
        setValidationMessage('');
    };

    const clearGrid = () => {
        setRows([]);
        setTotalCount(0);
        setPage(1);
    };

    const onStartDateChange = (e) => {
        setStartDate(e.target.value);
        clearGrid();
        setValidationMessage('');
    };

    const onEndDateChange = (e) => {
        setEndDate(e.target.value);
        clearGrid();
        setValidationMessage('');
    };

    // pulls ALL rows from your backend in chunks
    const fetchAllRows = async () => {
        if (!startDate || !endDate) {
            toast.warn('Select both dates before export');
            return [];
        }
        if (endDate < startDate) {
            toast.warn('Fix the date range before export');
            return [];
        }

        const CHUNK = 1000; // adjust if you like
        let all = [];
        let skip = 0;

        // first page to get totalCount
        const first = await axios.post(`${config.hostname}/datagrid/getdatagrid`, {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            skip: 0,
            limit: CHUNK
        }, configheader);

        const total = Number(first.data?.totalCount || 0);
        const firstRows = Array.isArray(first.data?.data) ? first.data.data : [];
        all = all.concat(firstRows);
        skip += CHUNK;

        while (all.length < total) {
            const res = await axios.post(`${config.hostname}/datagrid/getdatagrid`, {
                concessionaire_id,
                property_access: propertyAccessNames,
                start_date: startDate,
                end_date: endDate,
                skip,
                limit: CHUNK
            }, configheader);

            const rows = Array.isArray(res.data?.data) ? res.data.data : [];
            all = all.concat(rows);
            skip += CHUNK;

            if (rows.length === 0) break;
        }
        return all;
    };


    // const exportFullCsvServer = async () => {
    //     if (!startDate || !endDate) { toast.warn('Select both dates first'); return; }
    //     if (endDate < startDate) { toast.warn('Fix the date range'); return; }

    //     try {
    //         setLoading(true);

    //         const params = {
    //             concessionaire_id,
    //             property_access: propertyAccessNames || '',
    //             start_date: startDate,
    //             end_date: endDate,
    //         };

    //         const res = await axios.get(
    //             `${config.hostname}/datagridexport/export-csv`,
    //             {
    //                 params,
    //                 headers: { Authorization: localStorage.getItem('sessiontoken') }, // your same token
    //                 responseType: 'blob',  // <— IMPORTANT
    //             }
    //         );

    //         // Download the CSV
    //         const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `grid_data_${startDate}_${endDate}.csv`; // or parse filename from header
    //         document.body.appendChild(a);
    //         a.click();
    //         a.remove();
    //         window.URL.revokeObjectURL(url);
    //     } catch (e) {
    //         console.error(e);
    //         toast.error('Export failed');
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const exportFullCsvServer = async () => {
        if (!startDate || !endDate) { toast.warn('Select both dates first'); return; }
        if (endDate < startDate) { toast.warn('Fix the date range'); return; }

        try {
            setLoading(true);

            const firstSort = (sortModelRef.current && sortModelRef.current[0]) || {};
            const sortField = firstSort.colId || undefined;
            const sortDir = firstSort.sort || undefined;


            const payload = {
                concessionaire_id,
                property_access: propertyAccessNames || '',
                start_date: startDate,
                end_date: endDate,
                filterModel: filterModelRef.current || {},
                sortField,
                sortDir,
                source
            };


            const res = await axios.post(
                `${config.hostname}/datagridexport/export-csv`,
                payload,
                {
                    headers: { Authorization: localStorage.getItem('sessiontoken') },
                    responseType: 'blob',
                }
            );

            const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${isUat ? 'uat_data_grid' : 'data_grid'}${startDate}_${endDate}.csv`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
            toast.error('Export failed');
        } finally {
            setLoading(false);
        }
    };


    return (
        <Fragment>
            <div className='theme-form'>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input
                                        className="form-control digits"
                                        id="startdate"
                                        type="date"
                                        value={startDate}
                                        max={today}
                                        onChange={onStartDateChange}
                                    />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input
                                        className="form-control digits"
                                        id="enddate"
                                        type="date"
                                        value={endDate}
                                        max={today}
                                        onChange={onEndDateChange}
                                    />
                                </FormGroup>
                                {validationMessage && <span className="text-danger">{validationMessage}</span>}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: onClickLoadData }}>
                                    Load Data
                                </Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: exportFullCsvServer }}>
                                    Export to CSV
                                </Btn>
                                <Btn attrBtn={{ color: 'secondary', className: 'me-3', onClick: reset }}>
                                    Reset
                                </Btn>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>

            {loading ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>
            ) : (
                <>
                    <div className="ag-theme-alpine" style={{ height: 600, width: '100%' }}>
                        {/* <AgGridReact
                            rowData={rows}
                            columnDefs={columns}
                            pagination={false}
                            onGridReady={onGridReady}
                            defaultColDef={{ sortable: true, filter: true, floatingFilter: true, resizable: true }}
                            gridOptions={{ sideBar: { toolPanels: ['columns'], defaultToolPanel: 'columns' } }}
                        /> */}
                        <AgGridReact
                            rowData={rows}
                            columnDefs={columns}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            onFilterChanged={onFilterChanged}
                            onSortChanged={onSortChanged}
                            pagination={false}
                        />
                    </div>

                    <div className="d-flex align-items-center mt-2">
                        <Btn attrBtn={{ color: 'light', className: 'me-2', onClick: goPrev, disabled: !canPrev }}>
                            ◀ Prev
                        </Btn>
                        <span>Page {page} of {totalPages} &nbsp;|&nbsp; {totalCount} rows</span>
                        <Btn attrBtn={{ color: 'light', className: 'ms-2', onClick: goNext, disabled: !canNext }}>
                            Next ▶
                        </Btn>
                    </div>
                </>
            )}
        </Fragment>
    );
};

export default DataGridView;






